import React, { Component, forwardRef, useState, useImperativeHandle, } from "react";
import Swal from "sweetalert2";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';


import { SearchField, SubmitSearch } from "../../components/design/layout/search";
import HeaderPage from "../../components/patterns/subpages/header";
import Button from "../../components/design/form/button"
import { Form, WrapperContent, ProductsGrid, QueryStatus, StatusText, FilterButton, WrappLoadMore, NoResultsBlock, ImageNoResults, NoTitle, OptionsList, OptionsListItem } from "./styles";

import $ from "jquery";

// Modal Bootstrap
import { Modal } from "react-bootstrap";

// Material ui
import Grid from "@material-ui/core/Grid";

import ProductBox from "../../components/design/layout/product-box";
import PartnerBox from "../../components/design/layout/partner-box";


//===============================================================================================================
// #4 - Import * UI Components
//===============================================================================================================
import { Filter, FilterHead, HistoryFilters, RemoveFilter } from "../../components/Filters";


//===============================================================================================================
// #4 - Import * Font Awesome Icons
//===============================================================================================================
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-light-svg-icons";
import { faChevronRight, faSearch } from "@fortawesome/pro-regular-svg-icons";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";

// Images

// Services
import OfferService from "../../services/Offer";
import Domain from '../../services/Domain';
import Categorization from '../../services/Categorization';
import PartnerService from '../../services/Partner';

import loadImage from "../../utils/LoadImage";
import ProductLoader from "../../components/design/layout/loader/product";
import PartnerLoader from "../../components/design/layout/loader/partner";
import handleURLExternal from "../../utils/handleURLParams";

import NoResults from "../../assets/images/no-result.png";

const ModalLoadMore = forwardRef((props, ref) => {
    // Bootstrap Modal
    const [show, setShow] = useState(false);

    // Handle Modal
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useImperativeHandle(ref, () => ({
        openModal: () => handleShow(),
        closeModal: () => handleClose(),
    }));

    return (
        <>
            <Modal
                show={show}
                size={!props.modalSize ? "size-45w" : props.modalSize}
                onHide={handleClose}
                className="full-width"
                centered
            >
                <Modal.Header closeButton>
                    <section className="_view-head">
                        <div className="_view-head-content" style={{}}>
                            <Button className="_back-history btn" onClick={handleClose}>
                                <Icon icon={faChevronLeft} />
                            </Button>
                            <Modal.Title> {props.modalTitle} </Modal.Title>
                        </div>
                    </section>
                </Modal.Header>
                <Modal.Body className="_modal-filter">{props.children}</Modal.Body>
            </Modal>
        </>
    );
});

class Results extends Component {

    constructor(props) {
        super(props);

        // Refs
        this.refLoadMoreModal = React.createRef();
        this.refLoadMoreSize = React.createRef();
        this.refLoadMoreBrand = React.createRef();

        this.state = {
            isLoading: false,
            isLoadingPartners: false,
            searchByClick: true,
            offers: null,
            searchedPartners: null,
            limit: 8,
            pageNumber: 0,
            amountItensNextPage: 0,
            searchString: "",
            idCategory: "",
            value: [0, 0],
            listConditions: [],
            listBrands: [],
            listCategorizations: [],
            listActiveCategorizations: [],
            listActiveSizes: [],
            searchFilters: {
                categorizations: []
            },
            key: '',
            category: '',
            tag: '',
            panelListSize: false,
            filterOpened: { order: false, categories: false, size: false, brand: false, condition: false, delivery: false, points: false },
            searchByPartner: false,
        };

        this.inputBrand = '';
        this.offerService = new OfferService();
        this.domain = new Domain();
        this.categorization = new Categorization();
        this.partnerService = new PartnerService();

        this.pageNumber = 0;
        this.aleatory = null;
    }

    loadResultsByUrlParams = (newSearch) => {

        let urlParams = new URLSearchParams(this.props.location.search);
        let keyParam = urlParams.get('key');
        let categoryParam = urlParams.get('category');
        let tagParam = urlParams.get('tag');
        let pageNumberParam = urlParams.get('pageNumber');
        let aleatory = urlParams.get('aleatory');
        let price = urlParams.get('price');
        let categoryList = urlParams.get('categoryList');
        let brand = urlParams.get('brand');
        let condition = urlParams.get('condition');
        let deliveryTypes = urlParams.get('deliveryTypes');
        let points = urlParams.get('points');
        let size = urlParams.get('size');
        let limit = urlParams.get('limit');
        let buscaParceiro = urlParams.get('buscaParceiro');

        if (limit) {
            this.setState({ limit: Number(limit) })
        } else {
            limit = this.state.limit
        }

        this.pageNumber = pageNumberParam;
        this.aleatory = aleatory;

        if (buscaParceiro) {
            this.searchByPartners(limit, keyParam);
            this.setState({ 'key': keyParam })
            this.setState({ 'searchByPartner': true });
        } else {
            this.search(
                keyParam,
                limit,
                categoryParam,
                tagParam,
                { sum: 0 },
                false,
                price ? price : null,
                points ? points : null,
                condition ? condition : null,
                categoryList ? categoryList : null,
                brand ? brand : null,
                deliveryTypes ? deliveryTypes : null,
                aleatory ? aleatory : null,
                size ? size : null
            );

            this.setState({ 'key': keyParam })
            this.setState({ 'category': categoryParam })
            this.setState({ 'tag': tagParam })
            this.setState({ 'searchByPartner': false });

            if (points) {
                let pontos = points.split('-');
                this.setState({ preco_min: pontos[0] });
                this.setState({ preco_max: pontos[1] });
            }

            let searchFiltersCopy = this.state.searchFilters;
            searchFiltersCopy.price = price ? { '_id': price, 'nome': price === -1 ? "Maior Preço" : "Menor Preço" } : null;
            searchFiltersCopy.deliveryTypes = deliveryTypes ? { _id: deliveryTypes, 'nome': deliveryTypes === "operador_logistico" ? "Correios" : "Entrega em maos" } : null;

            this.setState({ searchFilters: searchFiltersCopy })
        }
    }

    componentDidUpdate(prevProps) {
        //to detect URL query params update and backbutton
        if (this.props.location.search !== prevProps.location.search && this.props.history.action !== 'REPLACE') {
            let urlParams = new URLSearchParams(this.props.location.search);

            let newSearchParam = Boolean(urlParams.get('newSearch'));
            let category = urlParams.get('category');
            let categoryList = urlParams.get('categoryList');
            let points = urlParams.get('points');
            let size = urlParams.get('size');
            let limit = urlParams.get('limit');

            window.scrollTo(0, 0);

            let searchFilters = this.state.searchFilters;

            if (!category && !categoryList) {
                this.handleURLParams('categoryList', null);
                searchFilters.categorizations = [];
                localStorage.setItem('categorizations', []);
            } else if (category && searchFilters.categorizations) {
                this.handleURLParams('categoryList', null);
                searchFilters.categorizations = [];
            }

            if (!points) {
                this.setState({ preco_min: undefined });
                this.setState({ preco_max: undefined });
                searchFilters.points = null;
            }

            if (!size) {
                searchFilters.size = null;
            }

            if (!limit) {
                this.setState({ limit: 8 })
            }


            this.setState({ searchFilters: searchFilters });

            var currentSelected = null;
            var current = null;
            var upSpeed = 300;
            let tabs = $("._tabs");

            $("._dropdown-select").click(function () {
                $(this).children("._form-select-content").slideDown(upSpeed);

                if (current !== this) {
                    $(current).children("._form-select-content").slideUp(upSpeed);
                    current = this;
                } else {
                    current = null;
                }
            });

            $("._select-content").on("click", function () {
                let fieldValue = $(this).find("._current-item-name").text();

                if (currentSelected !== this) {
                    $(this)
                        .closest("._dropdown-select")
                        .find("._the-label > ._span-name")
                        .text(fieldValue);
                    currentSelected = this;
                } else currentSelected = null;
            });

            $(tabs).on("click", "._tab-item", function () {
                $(this)
                    .parents(tabs)
                    .find("._active")
                    .removeClass("_active")
                    .end()
                    .end()
                    .addClass("_active");
            });


            this.loadFiltersOptions();
            this.loadResultsByUrlParams(newSearchParam); // Carrega os resultados de acordo com os filtros da url
        }
    }

    componentWillUnmount() {
        let scroll = window.scrollY;

        if (this.props.history.location.pathname === '/produto') {
            localStorage.setItem('scrollY', scroll);
        }

        handleURLExternal({
            listOfKeyValues:
                [
                    //{ key: 'productId', value: undefined },
                    //{ key: 'partnerId', value: undefined },
                    { key: 'key', value: undefined },
                    { key: 'limit', value: undefined },
                    { key: 'price', value: undefined },
                    { key: 'categoryList', value: undefined },
                    { key: 'brand', value: undefined },
                    { key: 'condition', value: undefined },
                    { key: 'deliveryTypes', value: undefined },
                    { key: 'size', value: undefined },
                    { key: 'points', value: undefined },
                    { key: 'category', value: undefined }
                ],
            location: this.props.history.location,
            history: this.props.history
        })
    }

    componentDidMount() {
        var currentSelected = null;
        var current = null;
        var upSpeed = 300;
        let tabs = $("._tabs");

        $("._dropdown-select").click(function () {
            $(this).children("._form-select-content").slideDown(upSpeed);

            if (current !== this) {
                $(current).children("._form-select-content").slideUp(upSpeed);
                current = this;
            } else {
                current = null;
            }
        });

        $("._select-content").on("click", function () {
            let fieldValue = $(this).find("._current-item-name").text();

            if (currentSelected !== this) {
                $(this)
                    .closest("._dropdown-select")
                    .find("._the-label > ._span-name")
                    .text(fieldValue);
                currentSelected = this;
            } else currentSelected = null;
        });

        $(tabs).on("click", "._tab-item", function () {
            $(this)
                .parents(tabs)
                .find("._active")
                .removeClass("_active")
                .end()
                .end()
                .addClass("_active");
        });


        let urlParams = new URLSearchParams(this.props.location.search);
        let newSearchParam = Boolean(urlParams.get('newSearch'));


        this.loadFiltersOptions();
        this.loadResultsByUrlParams(newSearchParam); // Carrega os resultados de acordo com os filtros da url

        const ids = document.querySelectorAll("#filtros-desktop > .filtro");

        const activeFilter = (index) => {
            ids.forEach((filter) => {
                filter.classList.remove("active");
                filter.children[0].addEventListener("click", () => {

                    if ((" " + filter.className + " ").replace(/[\n\t]/g, " ").indexOf("active ") > -1) {
                        ids[index].classList.remove("active");

                    } else {
                        filter.classList.add("active");

                    }
                })
            });

            ids[index].classList.add("active");
        };

        ids.forEach((filter, index) => {
            filter.addEventListener("click", () => {
                activeFilter(index);
                filter.classList.add("active")
            });
        });
    }

    removeApplyedFilters = () => {
        Swal.fire('Aguarde...');
        Swal.showLoading();

        let categorys = document.querySelectorAll("#removeCategory");

        if (categorys) {
            categorys.forEach(element => {
                element.click();
            });
        }

        this.setState({ preco_min: undefined });
        this.setState({ preco_max: undefined });
        if (document.querySelector("#removeBrand")) document.querySelector("#removeBrand").click();
        if (document.querySelector("#removeCondition")) document.querySelector("#removeCondition").click();
        if (document.querySelector("#removeFrete")) document.querySelector("#removeFrete").click();
        if (document.querySelector("#removeOrdenarPor")) document.querySelector("#removeOrdenarPor").click()

        this.handleURLParams(null, null, [
            { key: 'key', value: undefined },
            { key: 'price', value: undefined },
            { key: 'categoryList', value: undefined },
            { key: 'brand', value: undefined },
            { key: 'condition', value: undefined },
            { key: 'deliveryTypes', value: undefined },
            { key: 'size', value: undefined },
            { key: 'points', value: undefined },
            { key: 'category', value: undefined }
        ])

        let listCategorizationReseted = [...this.state.listCategorizations]

        this.setState({
            key: undefined,
            category: undefined,
            listActiveCategorizations: listCategorizationReseted,
            searchFiltersApplied: {
                categorizations: []
            },
            searchFilters: {
                categorizations: []
            }
        }, () => {
            this.saveSelectedCategorizations([]);
            //document.querySelector("#btnAplicarFiltros").click();

            setTimeout(() => this.handleURLParams('limit', '8'), 2000);
            this.search(
                this.state.key,
                8,
                this.state.category,
                this.state.tag,
                { sum: 0 },
                true,
                this.state.searchFilters.price ? this.state.searchFilters.price._id : null,
                this.checkMinMaxValues(this.state.preco_min, this.state.preco_max),
                this.state.searchFilters.condition ? this.state.searchFilters.condition._id : null,
                this.state.searchFilters.categorizations.length > 0 ? this.formatCategoryList(this.state.searchFilters) : null,
                this.state.searchFilters.brand ? this.state.searchFilters.brand._id : null,
                this.state.searchFilters.deliveryTypes ? this.state.searchFilters.deliveryTypes._id : null,
                this.aleatory,
                this.state.searchFilters.size ? this.state.searchFilters.size._id : null
            );
        });

        Swal.close();

    }

    setActiveCategoryOnLoad(categorizations, index, listCategorizations) {
        if ((categorizations.length - 1) >= index) {
            let activeCategory = listCategorizations.filter((category) => category._id === categorizations[index]._id);

            if (activeCategory.length > 0) {
                let childListCategorizations = this.applyCategorizationFilter(activeCategory[0], null, true);
                this.setActiveCategoryOnLoad(categorizations, index + 1, childListCategorizations);
            }
        }
    }

    loadFiltersOptions = () => {

        let urlParams = new URLSearchParams(this.props.location.search);
        let brand = urlParams.get('brand');
        let category = urlParams.get('categoryList');
        let categoryHome = urlParams.get('category');

        //LISTA DE CATEGORIZACOES
        this.categorization.list().then((response) => {
            if (response.status === 200) {
                this.setState({ listCategorizations: response.data.payload });
                this.setState({ listActiveCategorizations: response.data.payload });

                if (category || categoryHome) {
                    let categorizations = JSON.parse(localStorage.getItem('categorizations'))
                    this.setActiveCategoryOnLoad(categorizations, 0, response.data.payload);

                }
            }
        })
            .catch((error) => {
                this.categorization.formatErrorMessage(error.response, 'RLICA');
                // console.log("ERROR", error.message);
            });

        //LISTA DE MARCAS
        this.domain.listBrands().then((response) => {
            if (response.status === 200) {
                this.setState({ listBrands: response.data.payload });

                let filteredBrand = response.data.payload.filter((item, index) => item._id === brand && brand);
                let searchFiltersCopy = this.state.searchFilters;
                searchFiltersCopy.brand = filteredBrand[0];
                this.setState({ searchFilters: searchFiltersCopy });
            }
        }).catch((error) =>
            this.domain.formatErrorMessage(error.response, 'RLIBDO1')
        );
    }

    checkMinMaxValues = (preco_min, preco_max) => {
        if (!preco_min && !preco_max) {
            return undefined;
        } else if (preco_min && !preco_max) {
            return `${preco_min}-99999`
        } else if (!preco_min && preco_max) {
            return `0-${preco_max}`
        } else {
            return `${preco_min}-${preco_max}`
        }
    }

    applyFilter = (filterName, filterValue, modalRef, executeSearch) => {
        let searchFilters = this.state.searchFilters;

        this.handleURLParams(filterName, filterValue?._id);

        if (!filterValue) {
            delete searchFilters[filterName];
        } else {
            searchFilters[filterName] = filterValue;
        }

        this.setState({ searchFilters: searchFilters });
        if (modalRef) modalRef.current.closeModal();

        //CHAMANDO BUSCA
        if (executeSearch) {
            this.search(
                this.state.key,
                this.state?.limit,
                this.state.category,
                this.state.tag,
                { sum: 0 },
                false,
                this.state.searchFilters.price ? this.state.searchFilters.price._id : null,
                this.checkMinMaxValues(this.state.preco_min, this.state.preco_max),
                this.state.searchFilters.condition ? this.state.searchFilters.condition._id : null,
                this.state.searchFilters.categorizations.length > 0 ? this.formatCategoryList(this.state.searchFilters) : null,
                this.state.searchFilters.brand ? this.state.searchFilters.brand._id : null,
                this.state.searchFilters.deliveryTypes ? this.state.searchFilters.deliveryTypes._id : null,
                this.aleatory,
                this.state.searchFilters.size ? this.state.searchFilters.size._id : null
            );
        }

    }

    resetInput = (inputName) => {
        $(`input[name="${inputName}"]:checked`).prop('checked', false);
    }

    clone = (obj) => {
        if (null == obj || "object" != typeof obj) return obj;
        var copy = obj.constructor();
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
        }

        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (var i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.clone(obj[i]);
            }
            return copy;
        }
        return copy;
    }

    saveSelectedCategorizations = (categorizations) => {
        let listToSave = this.clone(categorizations);

        localStorage.setItem('categorizations', JSON.stringify(listToSave.map(cat => {
            delete cat.oldCategorizationList;
            delete cat.categorias;
            delete cat.tipos_produtos;
            delete cat.produtos;

            return cat;
        })));
    }

    applyCategorizationFilter = (categorization, modalRef, notSaveFilter, loadSize) => {
        let searchFilters = this.state.searchFilters;

        this.handleURLParams('categoryList', categorization._id);

        categorization.oldCategorizationList = this.state.listActiveCategorizations;
        searchFilters.categorizations.push(categorization);
        this.setState({ searchFilters: searchFilters });

        if (modalRef) modalRef.current.closeModal();

        if (categorization.categorias && categorization.categorias.length > 0) {
            this.setState({ listActiveCategorizations: categorization.categorias });
            if (!notSaveFilter) this.saveSelectedCategorizations(searchFilters.categorizations);

            return categorization.categorias;

        } else if (
            categorization.tipos_produtos &&
            categorization.tipos_produtos.length > 0
        ) {

            this.setState({ listActiveCategorizations: categorization.tipos_produtos });
            if (!notSaveFilter) this.saveSelectedCategorizations(searchFilters.categorizations);

            return categorization.tipos_produtos

        } else if (categorization.produtos && categorization.produtos.length > 0) {

            this.setState({ listActiveCategorizations: categorization.produtos });
            if (!notSaveFilter) this.saveSelectedCategorizations(searchFilters.categorizations);

            return categorization.produtos;

        } else {

            this.setState({ listActiveCategorizations: [] });
            if (!notSaveFilter) this.saveSelectedCategorizations(searchFilters.categorizations);

            return [];

        }

    }

    removeCategorizationFilter = (categorization, index, executeSearch) => {

        let searchFilters = this.state.searchFilters;

        let oldCategorizationList;
        if (!categorization.oldCategorizationList) {
            oldCategorizationList = this.state.listCategorizations;
            searchFilters.categorizations = [];
        } else {
            oldCategorizationList = categorization.oldCategorizationList;
            searchFilters.categorizations = searchFilters.categorizations.slice(0, index);
        }

        if (searchFilters.categorizations.length === 0) {
            this.handleURLParams('categoryList', null);

            setTimeout(() => this.handleURLParams('size', null), 1000);
            //this.setState({ listActiveSizes: [] });
            searchFilters.size = null;

            localStorage.setItem('categorizations', []);
        }

        this.setState({ listActiveCategorizations: oldCategorizationList, searchFilters: searchFilters });

        //CHAMANDO BUSCA
        if (executeSearch) {
            this.search(
                this.state.key,
                this.state?.limit,
                this.state.category,
                this.state.tag,
                { sum: 0 },
                false,
                this.state.searchFilters.price ? this.state.searchFilters.price._id : null,
                this.checkMinMaxValues(this.state.preco_min, this.state.preco_max),
                this.state.searchFilters.condition ? this.state.searchFilters.condition._id : null,
                this.state.searchFilters.categorizations.length > 0 ? this.formatCategoryList(this.state.searchFilters) : null,
                this.state.searchFilters.brand ? this.state.searchFilters.brand._id : null,
                this.state.searchFilters.deliveryTypes ? this.state.searchFilters.deliveryTypes._id : null,
                this.aleatory,
                this.state.searchFilters.size ? this.state.searchFilters.size._id : null
            );
        }

    }

    formatCategoryList = (searchFilters) => {
        return searchFilters.categorizations.reduce((stringCategory, category, index) => {
            if (index === searchFilters.categorizations.length - 1) {
                stringCategory += category._id
            } else {
                stringCategory += `${category._id},`
            }

            return stringCategory;
        }, "")
    }

    loadMore = () => {
        this.setState({ limit: this.state.limit += 8 })

        // this.loadScamberAdsByStoreUrl(this.state.storeUrl,this.state.limit);
        this.setState({
            showFilter: false,
        });

        this.search(
            this.state.key,
            this.state?.limit,
            this.state.category,
            this.state.tag,
            { sum: 0 },
            false,
            this.state.searchFilters.price ? this.state.searchFilters.price._id : null,
            this.checkMinMaxValues(this.state.preco_min, this.state.preco_max),
            this.state.searchFilters.condition ? this.state.searchFilters.condition._id : null,
            this.state.searchFilters.categorizations.length > 0 ? this.formatCategoryList(this.state.searchFilters) : null,
            this.state.searchFilters.brand ? this.state.searchFilters.brand._id : null,
            this.state.searchFilters.deliveryTypes ? this.state.searchFilters.deliveryTypes._id : null,
            this.aleatory,
            this.state.searchFilters.size ? this.state.searchFilters.size._id : null
        );

        // Adicionando o numero de itens url.
        this.handleURLParams('limit', this.state.limit);

    }

    loadMorePartner = () => {
        this.setState({ limit: this.state.limit += 8 })

        this.setState({
            showFilter: false,
        });
        this.searchByPartners(this.state.limit, this.state.key);

        // Adicionando o numero de itens url.
        this.handleURLParams('limit', this.state.limit);

    }

    handleURLParams = (key, value, listOfKeyValues) => {
        let urlParams = new URLSearchParams(this.props.location.search);

        if (listOfKeyValues && listOfKeyValues.length > 0) {
            listOfKeyValues.map(keyValue => {
                if (!keyValue.value) {
                    urlParams.delete(keyValue.key);
                } else if (urlParams.get(keyValue.key)) {
                    urlParams.set(keyValue.key, keyValue.value)
                } else {
                    urlParams.append(keyValue.key, keyValue.value)
                }
            })
        } else {
            if (!value) {
                urlParams.delete(key);
            } else if (urlParams.get(key)) {
                urlParams.set(key, value)
            } else {
                urlParams.append(key, value)
            }
        }

        this.props.history.replace({ search: urlParams.toString() });
    }

    searchByPartners = (limit, key) => {
        this.setState({ isLoadingPartners: true });
        this.partnerService.listBySearch({ limit: limit, search: key }).then(response => {
            
            this.setState({ searchedPartners: response.data.payload });

            if (response.data.payload) {
                this.setState({ isLoadingPartners: false });
            }

        }).catch((error) =>
            this.scamber.formatErrorMessage(error.response, 'RFIST'),
        );
    }

    search = (key, limit, category, tag, countPage, newSearch, price, points, condition, categoryList, brand, deliveryType, aleatory, size) => {
        this.setState({ isLoading: true });
        setTimeout(() => {
            let newFiltersApplieds = { ...this.state.searchFilters };
            newFiltersApplieds.categorizations = this.clone(newFiltersApplieds.categorizations);

            this.setState({ searchFiltersApplied: newFiltersApplieds });
        }, 500);

        if (key) {
            if (key.indexOf('&') !== -1) key = key.replace(/&/g, 'ampersand');
        }

        if (newSearch) this.pageNumber = 1;

        this.offerService
            .listBySearch({
                search: key ? key : null,
                limit: limit ? limit : 8,
                categoryList: categoryList ? categoryList : null,
                tag: tag ? tag : null,
                aleatory: aleatory ? aleatory : null,
            })
            .then((response) => {
                
                if (response.data.payload.length <= 0)
                    this.setState({ pageNumber: (this.pageNumber -= 1) });
                this.setState({ offers: response.data.payload });

                if (response.data.payload) {
                    this.setState({ isLoading: false, isLoadingPartners: false });
                }

                let scrollY = localStorage.getItem('scrollY');
                if (scrollY) {
                    window.scrollTo(scrollY, scrollY);
                    localStorage.removeItem('scrollY');
                }
            })
            .catch((error) =>
                this.offerService.formatErrorMessage(error.response, 'RFIUAD1'),
            );
        setTimeout(() => {
            this.handleURLParams('points', points);
        }, 500);
    };

    filterBrands = (e, filter) => {
        if (e) e.preventDefault();
        // this.inputBrand = e.target.value;
        if (filter) if (filter.indexOf('&') !== -1) filter = filter.replace(/&/g, 'ampersand');
        this.domain.listBrands(filter).then((response) => {
            if (response.status === 200) {
                this.setState({ listBrands: response.data.payload });
            }
        }).catch((error) =>
            this.domain.formatErrorMessage(error.response, 'RLIBDO2'),
        );
    }

    // Functions Filters

    handleShowFilter = () => {
        this.setState({
            showFilter: !this.state.showFilter,
        });
    };

    handleCloseFilter = () => {
        this.setState({
            showFilter: false,
        });
    };

    handleShowOrderFilter = () => {
        this.setState({
            showOrderFilter: !this.state.showOrderFilter,
        });
    };

    handleCloseOrderFilter = () => {
        this.setState({
            showOrderFilter: false,
        });
    };

    removeFilterBrand = (filterName, filterValue, modalRef, executeSearch) => {
        let searchFilters = this.state.searchFilters;

        this.handleURLParams(filterName, filterValue?._id);

        if (!filterValue) {
            delete searchFilters[filterName];
        } else {
            searchFilters[filterName] = filterValue;
        }

        this.setState({ searchFilters: searchFilters });
        if (modalRef) modalRef.current.closeModal();

        // RESETANDO A LISTA DE MARCAS
        this.filterBrands(null, '');

        if (executeSearch) {
            this.search(
                this.state.key,
                this.state?.limit,
                this.state.category,
                this.state.tag,
                { sum: 0 },
                false,
                this.state.searchFilters.price ? this.state.searchFilters.price._id : null,
                this.checkMinMaxValues(this.state.preco_min, this.state.preco_max),
                this.state.searchFilters.condition ? this.state.searchFilters.condition._id : null,
                this.state.searchFilters.categorizations.length > 0 ? this.formatCategoryList(this.state.searchFilters) : null,
                this.state.searchFilters.brand ? this.state.searchFilters.brand._id : null,
                this.state.searchFilters.deliveryTypes ? this.state.searchFilters.deliveryTypes._id : null,
                this.aleatory,
                this.state.searchFilters.size ? this.state.searchFilters.size._id : null
            );
        }
    }

    hasChindren = (categorization) => {
        if (categorization.categorias && categorization.categorias.length >= 0) {
            return true;
        } else if (
            categorization.tipos_produtos &&
            categorization.tipos_produtos.length >= 0
        ) {
            return true;
        } else if (categorization.produtos && categorization.produtos.length >= 0) {
            return true;
        }

        return false;
    };

    openFilter = (filterName) => {

        let filter = this.state.filterOpened;

        for (let key in filter) {

            if (key === filterName) {
                filter[key] = !filter[key]
            } else {
                filter[key] = false;
            }
        }

        this.setState({
            filterOpened: filter
        });
    }

    
    render() {

        const urlParams = new URLSearchParams(window.location.search);
        const withRequiredParameters = (!!urlParams.get('tail') || !!urlParams.get('categories'));

        return (
            <>
                <div id="view_results">
                    <HeaderPage borderBottom={true} activeBackHistory={withRequiredParameters} columnContent={<FilterButton type="button" onClick={this.handleShowFilter}> <Icon icon={["far", "filter"]} /> Filtros</FilterButton>}>
                        <Form onSubmit={(e) => console.log(e)}>
                            <SearchField
                                placeholder={`Faça uma busca`}
                                type="text"
                                name="search"
                                readOnly={true}
                                onClick={() => this.props.history.push({ pathname: "/search", search: this.props.history.location.search })}
                            />

                            <SubmitSearch type="button" onClick={() => this.props.history.push({ pathname: "/search", search: this.props.history.location.search })} />
                        </Form>
                    </HeaderPage>

                    <WrapperContent zIndex={this.state.showFilter ? 997 : 994}>
                        <QueryStatus>
                            {this.state.key ? (<>Resultados para <StatusText>"{decodeURIComponent(this.state.key)}"</StatusText></>) : (<></>)}
                        </QueryStatus>

                        <div className="wrapper-mobile-filters-head">
                            <>
                                {!this.state.offers?.length === 0 ? null : (
                                    <>
                                        {/* <MobileFiltersBar>
                                            <FiltersBarItem text="Ordenar" icon={<Icon icon={faChevronDown} />} className="chevron" onClick={this.handleShowOrderFilter} />
                                            <FiltersBarItem text="Filtros" icon={<TuneIcon />} className="chevron" onClick={this.handleShowFilter} />
                                        </MobileFiltersBar> */}

                                        {this.state.searchFiltersApplied && (this.state.searchFiltersApplied.price || this.state.searchFiltersApplied.categorizations?.length > 0 ||
                                            this.state.searchFiltersApplied.size || this.state.searchFiltersApplied.brand || this.state.searchFiltersApplied.condition ||
                                            this.state.searchFiltersApplied.deliveryTypes || this.state.preco_min || this.state.preco_max) ?
                                            <div className="current-selected-filters">
                                                <div className="current-filters">
                                                    <h2>Filtros<br /> ativos:</h2>
                                                    <HistoryFilters>
                                                        {/* {!this.state.searchFiltersApplied.price ? (
                                                            <RemoveFilter text={this.state.searchFiltersApplied.price.nome} subtitle="Ordenar por:" onClick={() => { this.applyFilter("price", undefined, null, true); this.resetInput('ordenation'); }} />
                                                        ) : null} */}

                                                        {this.state.searchFiltersApplied.categorizations?.length > 0 ? (
                                                            <>
                                                                {this.state.searchFiltersApplied.categorizations.map((categorization, index) => {
                                                                    return (<RemoveFilter text={categorization.nome} subtitle="Categorias:" onClick={() => this.removeCategorizationFilter(categorization, index, true)} />)
                                                                }
                                                                )}
                                                            </>
                                                        ) : null}

                                                        {this.state.searchFiltersApplied.size ? (
                                                            <RemoveFilter text={this.state.searchFiltersApplied.size.nome} subtitle="Tamanho:" onClick={() => { this.applyFilter("size", undefined, null, true); this.resetInput('size') }} />
                                                        ) : null}

                                                        {this.state.searchFiltersApplied.brand ? (
                                                            <RemoveFilter text={this.state.searchFiltersApplied.brand.nome} subtitle="Marcas:" onClick={(e) => { this.removeFilterBrand("brand", undefined, null, true); this.resetInput('select_brand'); }} />
                                                        ) : null}

                                                        {this.state.searchFiltersApplied.condition ? (
                                                            <RemoveFilter text={this.state.searchFiltersApplied.condition.nome} subtitle="Condição:" onClick={() => { this.applyFilter("condition", undefined, null, true); this.resetInput('condition'); }} />
                                                        ) : null}

                                                        {this.state.searchFiltersApplied.deliveryTypes ? (
                                                            <RemoveFilter text={this.state.searchFiltersApplied.deliveryTypes.nome} subtitle="Frete:" onClick={() => { this.applyFilter("deliveryTypes", undefined, null, true); this.resetInput('select_delivery_type'); }} />
                                                        ) : null}

                                                        {this.state.preco_min || this.state.preco_max ? (
                                                            <>
                                                                <RemoveFilter text={`Minimo ${this.state.preco_min ? this.state.preco_min : 0} / Máximo ${this.state.preco_max ? this.state.preco_max : 99999}`} subtitle="Pontos:" onClick={() =>
                                                                    this.setState({ preco_min: undefined, preco_max: undefined }, () => {
                                                                        this.search(
                                                                            this.state.key,
                                                                            8,
                                                                            this.state.category,
                                                                            this.state.tag,
                                                                            { sum: 0 },
                                                                            true,
                                                                            this.state.searchFilters.price ? this.state.searchFilters.price._id : null,
                                                                            this.checkMinMaxValues(this.state.preco_min, this.state.preco_max),
                                                                            this.state.searchFilters.condition ? this.state.searchFilters.condition._id : null,
                                                                            this.state.searchFilters.categorizations.length > 0 ? this.formatCategoryList(this.state.searchFilters) : null,
                                                                            this.state.searchFilters.brand ? this.state.searchFilters.brand._id : null,
                                                                            this.state.searchFilters.deliveryTypes ? this.state.searchFilters.deliveryTypes._id : null,
                                                                            this.aleatory,
                                                                            this.state.searchFilters.size ? this.state.searchFilters.size._id : null
                                                                        )
                                                                    })
                                                                } />
                                                            </>
                                                        ) : null}

                                                    </HistoryFilters>
                                                </div>
                                                <div className="clear-filters">
                                                    <button type="button" className="btn" onClick={(e) => { e.preventDefault(); this.removeApplyedFilters(); }}>
                                                        Limpar filtros
                                                    </button>
                                                </div>
                                            </div>
                                            : null
                                        }
                                    </>
                                )}
                            </>
                        </div>

                        {!this.state.searchedPartners ? (
                            <section className="_store-content">

                                {!this.state.offers?.length === 0 ? <></> : (
                                    <div className="filter">


                                        <div className={this.state.showFilter ? "_wrap-filters _filter-show" : "_wrap-filters"}>

                                            <form id="form-filters" className="_form _sidebar">
                                                <FilterHead title="Filtros Geral" onClick={this.handleCloseFilter}>

                                                    <div className="clear-filters">
                                                        <button type="submit" className="btn" onClick={(e) => { e.preventDefault(); this.removeApplyedFilters(); }}>
                                                            Limpar filtros
                                                        </button>
                                                    </div>

                                                </FilterHead>

                                                <Filter filterTitle="Categorias" open={this.state.filterOpened.categories} activeFilterSelected={this.state.searchFilters.categorizations?.length > 0 ? "active" : "no-active"} onClick={() => this.openFilter("categories")} closeFilter={this.handleCloseFilter} activeFilters={
                                                    <>
                                                        {this.state.searchFilters.categorizations?.length > 0 ? (
                                                            <>
                                                                {this.state.searchFilters.categorizations.map((categorization, index) =>
                                                                    <span>{categorization.nome}</span>
                                                                )}
                                                            </>
                                                        ) : (<></>)}
                                                    </>
                                                }>

                                                    {this.state.searchFilters.categorizations?.length > 0 ? (
                                                        <HistoryFilters>
                                                            <>
                                                                {this.state.searchFilters.categorizations.map((categorization, index) =>
                                                                    <RemoveFilter text={categorization.nome} onClick={() => this.removeCategorizationFilter(categorization, index)} />
                                                                )}
                                                            </>
                                                        </HistoryFilters>
                                                    ) : (<></>)}

                                                    <div className="wrap-filter-results">
                                                        {this.state.listActiveCategorizations?.length > 0 ? this.state.listActiveCategorizations.map((categorization, index) => (
                                                            <label key={index} className="_filter-label">
                                                                <input onClick={() => this.applyCategorizationFilter(categorization, null, null, true)} type="radio" name="categorization" checked={false} />
                                                                <span className="_filter-title">{categorization.nome}</span>

                                                                {this.hasChindren(categorization) ? (<div className="chevron-icon"> <Icon icon={faChevronRight} /> </div>) : (<div className="check-mark"> <Icon icon={faCheck} /> </div>)}

                                                            </label>
                                                        )) : (<></>)}
                                                    </div>

                                                    <div className="filter-actions">

                                                        <Button
                                                            type="submit"
                                                            styleType="bordered"
                                                            buttonSize="small"
                                                            buttonColor="#F6F6F9"
                                                            textColor="#515157"
                                                            buttonText={`Limpar`}
                                                            borderColor="#F6F6F9"
                                                            maxWidth={200}
                                                            onClick={(e) => {
                                                                this.openFilter("order");
                                                                e.preventDefault();
                                                                this.removeApplyedFilters();
                                                            }}
                                                        />
                                                        <Button
                                                            type="submit"
                                                            styleType="bordered"
                                                            buttonSize="small"
                                                            buttonColor="#1852CC"
                                                            textColor="#FFFFFF"
                                                            buttonText={`Aplicar`}
                                                            borderColor="#1852CC"
                                                            maxWidth={200}
                                                            onClick={this.handleCloseFilter, (e) => {
                                                                this.openFilter("categories");
                                                                e.preventDefault();
                                                                window.scrollTo(0, 0);
                                                                this.setState({
                                                                    showFilter: false,
                                                                    searchByClick: false,
                                                                    limit: 8
                                                                });
                                                                setTimeout(() => this.handleURLParams('limit', '8'), 2000);
                                                                this.search(
                                                                    this.state.key,
                                                                    8,
                                                                    this.state.category,
                                                                    this.state.tag,
                                                                    { sum: 0 },
                                                                    true,
                                                                    this.state.searchFilters.price ? this.state.searchFilters.price._id : null,
                                                                    this.checkMinMaxValues(this.state.preco_min, this.state.preco_max),
                                                                    this.state.searchFilters.condition ? this.state.searchFilters.condition._id : null,
                                                                    this.state.searchFilters.categorizations.length > 0 ? this.formatCategoryList(this.state.searchFilters) : null,
                                                                    this.state.searchFilters.brand ? this.state.searchFilters.brand._id : null,
                                                                    this.state.searchFilters.deliveryTypes ? this.state.searchFilters.deliveryTypes._id : null,
                                                                    this.aleatory,
                                                                    this.state.searchFilters.size ? this.state.searchFilters.size._id : null
                                                                );
                                                            }}
                                                        />

                                                    </div>

                                                </Filter>

                                            </form>
                                        </div>
                                    </div>
                                )}

                                {this.state.isLoading && (
                                    <ProductsGrid>
                                        <Grid container spacing={0}>
                                            {[0, 1, 3, 4].map((item, i) =>
                                                <Grid key={`${item}-${i}`} item xs={6}>
                                                    <ProductLoader />
                                                </Grid>
                                            )}
                                        </Grid>
                                    </ProductsGrid>
                                )}

                                {this.state.isLoadingPartners && (
                                    <ProductsGrid>
                                        <Grid container spacing={0}>
                                            {[0, 1, 3, 4].map(() =>
                                                <Grid item xs={12}>
                                                    <PartnerLoader />
                                                </Grid>
                                            )}
                                        </Grid>
                                    </ProductsGrid>
                                )}

                                {this.state.offers?.length === 0 && (
                                    <NoResultsBlock>
                                        <ImageNoResults src={NoResults} alt="Nenhum resultado encontrado" />
                                        <NoTitle>
                                            Ops! Sua busca não encontrou resultados.
                                        </NoTitle>
                                        <OptionsList>
                                            <OptionsListItem>- Tente buscar palavras menos específicas.</OptionsListItem>
                                            <OptionsListItem>- Tente buscar palavras diferentes.</OptionsListItem>
                                            <OptionsListItem>- Digite no minimo 3 caracteres.</OptionsListItem>
                                        </OptionsList>
                                    </NoResultsBlock>
                                )}

                                <ProductsGrid>
                                    <Grid container spacing={1}>
                                        {this.state.offers?.map((item) => (
                                            <Grid item xs={6}>
                                                <ProductBox
                                                    gridMargin={0}
                                                    productBrand={item.marca ? item.marca.nome : null}
                                                    productId={item._id}
                                                    discountValue={item.descont ? item.descont : null}
                                                    productTitle={item.titulo}
                                                    image={loadImage({ imageCode: item.imagens[0] })}
                                                    productPrice={item.oferta}
                                                    productType={item.tipo_oferta}
                                                    priceColor={props => props.theme[this.props.website]?.components.productBox.priceColor}
                                                    announcedBy={item.empresa ? this.props.website : 'parceiro'}
                                                    company={this.props.website}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>


                                    <WrappLoadMore>
                                        {this.state.limit <= this.state.offers?.length && (
                                            <Button
                                                styleType="default"
                                                buttonSize="small"
                                                buttonColor={props => props.theme[this.props.website]?.button.background}
                                                textColor={props => props.theme[this.props.website]?.button.color}
                                                borderColor={props => props.theme[this.props.website]?.button.background}
                                                buttonText="Mostrar mais ofertas"
                                                maxWidth={200}
                                                onClick={() => this.loadMore()}
                                            />
                                        )}

                                    </WrappLoadMore>

                                </ProductsGrid>

                            </section>
                        ) : (
                            <section className="_store-content">

                                {this.state.searchedPartners?.length === 0 && (
                                    <NoResultsBlock>
                                        <ImageNoResults src={NoResults} alt="Nenhum resultado encontrado" />
                                        <NoTitle>
                                            Ops! Sua busca não encontrou resultados.
                                        </NoTitle>
                                        <OptionsList>
                                            <OptionsListItem>- Tente buscar palavras menos específicas.</OptionsListItem>
                                            <OptionsListItem>- Tente buscar palavras diferentes.</OptionsListItem>
                                            <OptionsListItem>- Digite no minimo 3 caracteres.</OptionsListItem>
                                        </OptionsList>
                                    </NoResultsBlock>
                                )}

                                <ProductsGrid>

                                    <Grid container spacing={1}>
                                        {this.state.searchedPartners?.map((item) => (
                                            <Grid item xs={12}>
                                                <PartnerBox
                                                    title={item.nome}
                                                    cover={loadImage({ imageCode: item.imagem_banner })}
                                                    partnerLogo={loadImage({ imageCode: item.imagem_avatar })}
                                                    partnerId={item._id}
                                                    partnerUrl={item.website}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>

                                    <WrappLoadMore>
                                        {this.state.limit <= this.state.searchedPartners?.length && (
                                            <Button
                                                styleType="bordered"
                                                buttonSize="small"
                                                buttonColor="#FFFFFF"
                                                textColor="#1852CC"
                                                buttonText="Mostrar mais parceiros"
                                                borderColor="#1852CC"
                                                maxWidth={200}
                                                onClick={() => this.loadMorePartner()}
                                            />
                                        )}

                                    </WrappLoadMore>

                                </ProductsGrid>

                            </section>
                        )}
                    </WrapperContent>
                </div>


                {/* MODAIS */}
                <ModalLoadMore modalTitle="Categorias" ref={this.refLoadMoreModal}>
                    <form className="form form-filter">

                        <div className="search">

                        </div>

                        <div className="_wrap-items">
                            <Grid container spacing={2}>
                                {this.state.listActiveCategorizations?.map((categorization, index) => (
                                    <Grid item lg={4} md={4} sm={12} xs={12} key={index}>

                                        <button type="button" className="btn-select--filter" onClick={() => this.applyCategorizationFilter(categorization, this.refLoadMoreModal, null, true)} name="categorization">
                                            {categorization.nome}
                                            <Icon icon={faCheck} />
                                        </button>
                                    </Grid>
                                ))
                                }
                            </Grid>
                        </div>
                    </form>
                </ModalLoadMore>

                <ModalLoadMore modalTitle="Selecione o tamanho" ref={this.refLoadMoreSize} modalSize="size-32w">
                    <form className="form form-filter">

                        <div className="_wrap-items _sizes">

                            {this.state.listActiveSizes?.map((sizeGroup, index) => (
                                <>
                                    <div className="FilterHead">
                                        <div key={index} className="_filter-selected">
                                            {sizeGroup.nome}
                                        </div>
                                    </div>
                                    <Grid container spacing={2}>

                                        {sizeGroup.tamanhos.map((size, index) => (
                                            <Grid item lg={2} md={2} sm={2} xs={4} key={index}>
                                                <button type="button" className="btn-select--filter bordered" onClick={() => this.applyFilter("size", size, this.refLoadMoreSize)} name="size">
                                                    <span>
                                                        {size.nome}
                                                    </span>
                                                    <Icon icon={faCheck} />
                                                </button>
                                            </Grid>
                                        ))}

                                    </Grid>
                                </>
                            ))
                            }
                        </div>
                    </form>
                </ModalLoadMore>

                <ModalLoadMore modalTitle="Marca" ref={this.refLoadMoreBrand}>
                    <form onSubmit={(e) => this.filterBrands(e, this.inputBrand)} className="form form-filter _brands">

                        <div className="search">

                            <div className="form-group search mobile">
                                <input onChange={(e) => this.inputBrand = e.target.value} type="text" placeholder="Busque por 'Zara'" />
                                <button type="submit">
                                    <Icon icon={faSearch} className="fa-question-circle" />
                                </button>
                            </div>

                        </div>

                        <div className="_wrap-items">


                            <Grid container spacing={2}>
                                {this.state.listBrands.map((brand, index) => (
                                    <Grid item lg={4} md={4} sm={12} xs={12} key={index}>
                                        <button type="button" className="btn-select--filter" onClick={() => this.applyFilter("brand", brand, this.refLoadMoreBrand)}>
                                            {brand.nome}
                                            <Icon icon={faCheck} />
                                        </button>
                                    </Grid>
                                ))}
                            </Grid>
                        </div>
                    </form>
                </ModalLoadMore>

            </>
        );
    }
}

const mapStateToProps = (state) => ({
    site_properties: state.websiteReducer.site_properties,
    website: state.websiteReducer.website
})

export default withRouter(connect(mapStateToProps, {})(Results));
